










































import { Input, InputLabel, InputError, CustomLink, AltInputLabel } from '../../atoms'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { EMAIL_FIELD_LIMIT } from '../../../utils/field-length'
import { userWithEmailExist, userWithEmailNotExist, userAlreadyUsed, CHALLENGE_EXPIRED } from '../../../utils/errors'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Input,
    InputLabel,
    InputError,
    CustomLink,
    AltInputLabel
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
})
export default class EmailInputGroup extends Vue {
  @Prop({ type: String, default: '' }) readonly altLabel?: string
  @Prop({ required: false, type: String }) readonly label?: string
  @Prop({ required: true, type: String }) readonly value!: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: Boolean, default: false }) readonly disabled?: boolean

  @Watch('error', { immediate: true, deep: true })
  onErrorChange(error: string) {
    if (error === CHALLENGE_EXPIRED) {
      setTimeout(() => {
        const baseURL = process.env.VUE_APP_FINNO_ENDPOINT || ''
        location.href = baseURL
      }, 1000)
    }
  }
  get showLoginPrompt(): boolean {
    return this.error === userWithEmailExist
  }
  get showRegisterPrompt(): boolean {
    return this.error === userWithEmailNotExist
  }
  get showContactUsPrompt(): boolean {
    return this.error === userAlreadyUsed
  }
  get emailFieldLimit(): number {
    return EMAIL_FIELD_LIMIT
  }
  goToRegister() {
    this.$router.push({ path: '/register' })
  }
  goToLogin() {
    this.$router.push({ path: '/login' })
  }
}
